// La capa ESPEJO que va detrás del textarea para resaltar `#colores`, `@menciones` y links
// (ADR-2026-10-04-colores-y-menciones-resaltados-en-la-caja). Un textarea no puede pintar
// partes de su texto: la caja lo vuelve transparente (dejándole el cursor y la selección) y
// esta capa, con LA MISMA tipografía y el mismo padding (`className`), repite el texto
// detrás con los tramos resaltados. Va `absolute inset-0` dentro de un envoltorio
// `relative` que mide lo que mide el textarea; el scroll se le copia desde afuera.
//
// El resaltado no puede cambiar el largo de los glifos (se descalcaría del textarea), así
// que el "aire" alrededor es una sombra del mismo color, no padding.

import { forwardRef } from 'react';
import type { ChatAttachment } from '../../pages/v2/agentAttachments';
import { segmentosDeTexto } from './resaltadoDeTexto';

const RESALTE = 'rounded-[4px] bg-[#E8EEFF] text-brand-primary shadow-[0_0_0_2px_#E8EEFF] [box-decoration-break:clone]';
/** Un link se ve como link (azul y subrayado), no como pastilla: así no se confunde con una
 *  mención (ADR-2026-10-15-los-links-se-ven-azules-en-la-caja). El subrayado no cambia el
 *  ancho de los glifos, así que la capa sigue calcando al textarea. */
const LINK = 'text-brand-primary underline underline-offset-2';

export const TextoResaltado = forwardRef<
  HTMLDivElement,
  { texto: string; adjuntos: readonly ChatAttachment[]; className: string }
>(({ texto, adjuntos, className }, ref) => (
  <div
    ref={ref}
    aria-hidden="true"
    className={`pointer-events-none absolute inset-0 overflow-hidden whitespace-pre-wrap break-words ${className}`}
  >
    {segmentosDeTexto(texto, adjuntos).map((s, i) =>
      s.tipo === 'texto' ? (
        <span key={i}>{s.texto}</span>
      ) : (
        <span key={i} className={s.tipo === 'link' ? LINK : RESALTE}>
          {s.texto}
        </span>
      ),
    )}
    {/* Un salto final en el textarea abre un renglón vacío; en un div no. El espacio de
        ancho cero lo abre acá también, para que midan igual. */}
    {'​'}
  </div>
));
TextoResaltado.displayName = 'TextoResaltado';
